/* 🤖 this file was generated by svg-to-ts */
export const matIconShowChart: {
  name: 'show-chart';
  data: string;
} = {
  name: 'show-chart',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="m3.5 18.49 6-6.01 4 4L22 6.92l-1.41-1.41-7.09 7.97-4-4L2 16.99l1.5 1.5z"/></svg>`
};
